import { gql, TypedDocumentNode } from "@apollo/client";
import type { BeneficiaryRecord } from "../person/queries";

export type BeneficiaryDesignationInput = {
  id?: string;
  fullName: string;
  dateOfBirth: string;
  ssnLast4?: string;
  relationship: string;
  percent: number;
  applicationType?: string;
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  country?: string | null;
  phone?: string | null;
  email?: string | null;
};

export type UpdateBeneficiariesInput = {
  personId: string;
  applicationType: string;
  primaryBeneficiaries: BeneficiaryDesignationInput[];
  contingentBeneficiaries?: BeneficiaryDesignationInput[];
};

export type UpdateBeneficiariesResponse = {
  updateBeneficiaries: {
    success: boolean;
    message: string;
    code: number;
    person: {
      id: string;
      beneficiaries: BeneficiaryRecord[];
    } | null;
  };
};

export type UpdateBeneficiariesVariables = {
  input: UpdateBeneficiariesInput;
};

export const UPDATE_BENEFICIARIES_MUTATION: TypedDocumentNode<
  UpdateBeneficiariesResponse,
  UpdateBeneficiariesVariables
> = gql`
  mutation UpdateBeneficiaries($input: BackofficeUpdateBeneficiariesInput!) {
    updateBeneficiaries(input: $input) {
      success
      message
      code
      person {
        id
        beneficiaries(includeInactive: true) {
          id
          fullName
          beneficiaryType
          relationship
          percent
          dateOfBirth
          ssnLast4
          applicationType
          effectiveStartDate
          effectiveEndDate
          address1
          address2
          city
          state
          postalCode
          country
          phone
          email
        }
      }
    }
  }
`;
